export type AssessoriaPerfil = 'jove' | 'familiar' | 'professional';

export enum AssessoriaPerfilEnum {
  jove = 'Jove',
  familiar = 'Familiar',
  professional = 'Professional',
}
